import { Component, OnInit, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { RestCallerService } from '../common/services/rest-caller.service';
import { ImpExportService } from '../common/services/imp-export.service';
import { OrderByPipe } from '../common/pipes/orderby.pipe';

declare var $: any;
declare var swal: any;
declare var alasql: any;
declare var moment: any;

@Component({
  selector: 'app-payroll-log',
  templateUrl: './payroll-log.component.html',
  styleUrls: ['./payroll-log.component.css'],
})

export class PayrollLogComponent implements OnInit, OnDestroy {

  showLoader: boolean = false;
  logData: Object[] = [];
  employeeData: Object[] = [];
  selectAll: boolean = false;
  fromSelectedDateString: string;
  fromDisplayDateString: string;
  toSelectedDateString: string;
  toDisplayDateString: string;
  fromInputDate: Date;
  toInputDate: Date;

  isDesc: boolean = false;
  column: string = 'CategoryName';
  direction: number;

  constructor(private restCallingService: RestCallerService, private impExportService: ImpExportService) {

  }

  ngOnDestroy() {
    $('.nav>li.active').removeClass("active");
  }

  ngOnInit() {
    $('#pay-log').addClass('active');
    this.fromInputDate = new Date(); 
    this.toInputDate = new Date();
    this.fromSelectedDateString = moment(this.fromInputDate).format('YYYY-MM-DD');
    this.toSelectedDateString = moment(this.toInputDate).format('YYYY-MM-DD');
  }

  resetDate() {
    this.fromInputDate = new Date(); 
    this.toInputDate = new Date();
    this.fromSelectedDateString = moment(this.fromInputDate).format('YYYY-MM-DD');
    this.toSelectedDateString = moment(this.toInputDate).format('YYYY-MM-DD');
    this.fromDisplayDateString = "";
    this.toDisplayDateString = "";
    this.logData = [];
  }

  toggleSelectAll() {
    this.selectAll = !this.selectAll;
    for (var rowIndex in this.logData) {
      let currentRow: any = this.logData[rowIndex];
      currentRow.selected = this.selectAll;
    }
  }

  updateFromDate(event) {
    this.fromSelectedDateString = moment(event).format('YYYY-MM-DD');
  }

  updateToDate(event) {
    this.toSelectedDateString = moment(event).format('YYYY-MM-DD');
  }

  getPayrollForDate() {
     this.fromDisplayDateString = this.fromSelectedDateString;
     this.toDisplayDateString = this.toSelectedDateString;
    if (this.fromSelectedDateString && this.toSelectedDateString) //checks if null or empty
      this.getPayrollLogs(this.fromSelectedDateString, this.toSelectedDateString); 
  }

  getPayrollLogs(fromDate: string, toDate: string) {
    this.showLoader = true;
    this.restCallingService.getPayrollV2Logs(fromDate, toDate).subscribe(
      data => {
        this.showLoader = false;
        this.logData = data.json();
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal("Failure", err.json().message, 'error');
      });
  }

  getSelectedEmployeePayrolls(payerId: string, employeeIds: number[]) {
    this.showLoader = true;
    this.restCallingService.getEmployeeListPayrollV2DataForCurrentQuarter(employeeIds).subscribe(
      data => {
        this.showLoader = false;
        this.doImpExport(payerId, employeeIds, data.json()); 
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal("Failure", err.json().message, "error");
      });
  }


  gatherExportData() {
    let employeeIds: number[] = [];
    let payerId: string;
    for (var rowIndex in this.logData) {
      let currentRow: any = this.logData[rowIndex];
      if (currentRow.selected == true) {
        employeeIds.push(currentRow.employeeId);
        if (!payerId)
          payerId = currentRow.payerId;
        else if (payerId !== currentRow.payerId) {
          swal("Failure", "All Employees MUST be for the same Payer", "error");
          return;
        }
      }
    }
    if (employeeIds.length == 0) {
      swal("No Records Selected", "Must select at least one record to export.", "warning");
      return;
    }
    this.getSelectedEmployeePayrolls(payerId, employeeIds);
  }

  findEmployeeById(id: number) {
    let currentEmployee = this.employeeData.find(employee => id == employee["id"]);
    return currentEmployee;
  }

  doImpExport(payerId: string, employeeIds: number[], payrollData: Object[]) {
    this.showLoader = true;
    this.restCallingService.getEmployeeListPayrollV2ExceptionDataForCurrentQuarter(employeeIds).subscribe(
      data => {
        this.showLoader = false;
        let exceptionRecords = data.json();
        let invalidRecords: Array<string> = [];
        exceptionRecords.forEach((record) => {
          invalidRecords.push(record['payDate']);
        });
        this.doWarningIfNecessary(invalidRecords, payerId, employeeIds, payrollData);
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal("Failure", err.json().message,'error');
      }
    );
  }

  doWarningIfNecessary(invalidRecords: Array<string>, payerId: string, employeeIds: number[], payrollData: Object[]) {
    if (invalidRecords.length > 0) {
      var el = document.createElement("p");
      el.innerHTML = 'Total Deductions do not match difference between Gross and Net on the Pay Dates shown below, continue? <br/><br/>';
      for (let date of invalidRecords) {
        el.innerHTML += moment(date).format('MMM DD, YYYY') + '<br/>';
      }
      swal({
        title: 'Are you Sure!', content: el, icon: 'warning', buttons: true
      }).then(
        (isConfirmed) => {
          if (isConfirmed) {
            this.impExportService.doImpExport2(payerId, employeeIds, payrollData);
          }
        });
    }
    else {
      this.impExportService.doImpExport2(payerId, employeeIds, payrollData);
    }
  }

  formatNannyDate(date: string) {
    let dateString: string;
    if (!date)
      dateString = ""
    else
      dateString = date.substring(5).replace("-", "/");
    return dateString;
  }

  getEmptyStringIfNull(property: string) {
    if (property) {
      return property;
    } else {
      return '';
    }
  }

  sort(property){
    this.isDesc = !this.isDesc;  
    this.column = property;
    this.direction = this.isDesc ? 1 : -1;
  };

  convertTimezone(timestamp) {
    try {
      var date = new Date(timestamp+" UTC");
      var momentDate = moment(date);
      if (!momentDate.isValid())
        return "";
      return momentDate.format('MMM DD, YYYY HH:mm:ss')
    } catch (e) {
      return "";
    }
  }

  exportCSV() {
    if (!this.logData)
      return;
    if (this.logData.length == 0) {
      swal('Error:', 'Table must contain at least one record to export.', 'warning');
      return;
    }
    let columnMap : Map<string,string> = new Map<string, string>();
    columnMap.set('payerId', 'Payer ID');
    columnMap.set('clientName', 'Client Name');
    columnMap.set('employeeName', 'Employee Name');
    columnMap.set('lastSubmittedBy', 'Last Submitted By') ;
    columnMap.set('lastSubmittedTimestamp', 'Last Submitted');
    columnMap.set('lastExportedTimestamp', 'Last Exported');
    let data: any = [];
    let columns: any = [];
    for (let colName of Array.from(columnMap.values())) {
      columns.push(colName);
    }
    data.push(columns);
    for(let row of this.logData) {
      let record: any = [];
      for (let col of Array.from(columnMap.keys())) {
        if (col.includes('Timestamp'))
            record.push(this.convertTimezone(row[col]) || '');
        else
          record.push(row[col] || '');
      }
      data.push(record);
    }
    alasql.promise('SELECT * INTO CSV("PAYROLL_SUBMISSIONS_EXPORT.CSV", {headers:false, separator:","\}) FROM ?', [data])
      .then(function () {
        console.log('Data saved');
      }).catch(function (err) {
        console.log('Error:', err);
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/payroll-log/payroll-log.component.ts